import BudgetFriendlyCarousel from '@/common/BudgetFriendlyCarousel';
import PopularBodyStyles from '@/common/PopularBodyStyles';
import ShopPopularModels from '@/common/ShopPopularModels';
import BrandMoment from './BrandMoment';
import Hero from './Hero';
import InternalLinks from './InternalLinks';
import MarketingCarousel from '../common/MarketingCarousel';
import PriceDropBanner from '../common/PriceDropBanner';

export default function NewUser() {
  return (
    <main data-testid="home-new-user" className="min-h-screen bg-white">
      <Hero />
      <PopularBodyStyles eventName="Home Feed Section" hasTopSpacing />
      <BudgetFriendlyCarousel eventName="Home Feed Section" />
      <ShopPopularModels eventName="Home Feed Section" />
      <PriceDropBanner />
      <MarketingCarousel />
      <BrandMoment>
        <InternalLinks />
      </BrandMoment>
    </main>
  );
}
